import { createRouter, createWebHashHistory } from 'vue-router';

import { useAuth } from '@/composables/useAuth';

const Dashboard = () => import('@views/DashboardView.vue');
const Heures = () => import('@views/HeuresView.vue');
const IA = () => import('@views/IAView.vue');
const Calendrier = () => import('@views/CalendrierView.vue');
const Profil = () => import('@views/ProfilView.vue');
const Soon = () => import('@views/SoonView.vue');
const Login = () => import('@views/auth/LoginView.vue');
const Signup = () => import('@views/auth/SignupView.vue');

const routes = [
  { path: '/', name: 'Dashboard', component: Dashboard, meta: { title: 'Tableau de bord', auth: true } },
  { path: '/heures', name: 'Heures', component: Heures, meta: { title: 'Mes heures', auth: true } },
  { path: '/ia', name: 'IA', component: IA, meta: { title: 'Assistant IA', auth: true } },
  { path: '/calendrier', name: 'Calendrier', component: Calendrier, meta: { title: 'Calendrier', auth: true } },
  { path: '/profil', name: 'Profil', component: Profil, meta: { title: 'Profil', auth: true } },
  { path: '/auth/login', name: 'Login', component: Login, meta: { title: 'Connexion', layout: 'auth' } },
  { path: '/auth/signup', name: 'Signup', component: Signup, meta: { title: 'Inscription', layout: 'auth' } },
  { path: '/:catchAll(.*)', component: Soon, meta: { title: 'Bientot', auth: true } },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to) => {
  const { isAuthenticated, ready } = useAuth();
  // We don't gate before the session is loaded — App.vue awaits loadSession() before
  // rendering. By the time the guard runs, isAuthenticated is trustworthy.
  if (!ready.value) return true;
  if (to.meta.auth && !isAuthenticated.value) {
    return { path: '/auth/login', query: { next: to.fullPath } };
  }
  if (to.meta.layout === 'auth' && isAuthenticated.value) {
    return { path: '/' };
  }
  return true;
});

router.afterEach((to) => {
  document.title = `${to.meta.title || 'Page'} - MyFranceAdmin`;
});

export default router;
